export const FORM_EDIT_MODE_CREATE = 'CREATE';
export const FORM_EDIT_MODE_MODIFY = 'MODIFY';
